/**
 * Pocket Universe — wallet transaction-simulation / security extension
 *
 * Declares a single web-accessible-resource group scoped to Polymarket only
 * (`https://polymarket.com` and its subdomains), not to every page. The group holds
 * `sidepanel.html` plus build-hashed bundles (`sidepanel.<hash>.js`,
 * `tabs/simulate.<hash>.css`) whose names rotate each release, so only `sidepanel.html`
 * is a stable probe target.
 *
 * Because the resources are origin-scoped, they are genuinely unreachable from anywhere
 * but Polymarket — a negative from any other page says nothing about the browser, only
 * about where the probe is running. Hence `requiredOrigin`.
 *
 * Manifest verified against version 2.13.1.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'gacgndbocaddlemdiaadajmlggabdeod';

export const pocketUniverse: ExtensionDefinition = {
  id: ID,
  name: 'Pocket Universe',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 100_000,
  requiredOrigin: 'https://polymarket.com',
  notes:
    'WAR scoped to polymarket.com, so only that site can detect it. The only ' +
    'non-hashed path is sidepanel.html; the JS/CSS bundles are build-hashed and skipped.',
  signals: [
    {
      id: 'war-sidepanel-html',
      kind: 'web-accessible-resource',
      description:
        'Fetch sidepanel.html — the extension side-panel page, exposed only to ' +
        'Polymarket origins. The only stable (non build-hashed) path in the WAR group.',
      weight: 1,
      run: () => probeFetch(ID, 'sidepanel.html'),
    },
  ],
};
